import React from 'react';
import {
  FiAlertTriangle,
  FiBarChart2,
  FiPower,
  FiMapPin,
  FiArrowRight,
} from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const ICON_MAP = {
  triangle: FiAlertTriangle,
  'bar-chart': FiBarChart2,
  power: FiPower,
  'map-pin': FiMapPin,
};

export const RecentAlerts = ({ data, isLoading = false }) => {
  const alerts = data || [];
  return (
    <div
      className={styles.quarterCard}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Recent Alerts</span>
        <button className={styles.viewLink}>View all</button>
      </div>

      <div className={styles.alertsList}>
        {!alerts.length && (
          <div
            style={{
              padding: '24px 0',
              textAlign: 'center',
              color: 'var(--gray-400)',
              fontSize: 13,
            }}
          >
            No alerts
          </div>
        )}
        {alerts.map((alert) => {
          const Icon = ICON_MAP[alert.iconType] || FiAlertTriangle;
          return (
            <div key={alert.id} className={styles.alertItem}>
              <div
                className={styles.alertIconWrapper}
                style={{ backgroundColor: alert.iconBg }}
              >
                <Icon size={15} color={alert.iconColor} />
              </div>

              <div className={styles.alertContent}>
                <span className={styles.alertTitle}>{alert.title}</span>
                <span className={styles.alertSubtitle}>{alert.subtitle}</span>
              </div>

              <span className={styles.alertTime}>{alert.time}</span>
            </div>
          );
        })}
      </div>

      <button className={styles.viewLink}>
        View full report <FiArrowRight size={13} />
      </button>
    </div>
  );
};
